import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Button, SvgIcon, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import Loader from 'src/components/LoaderImg/loader.gif';
import { getAllSubmittedDocs, getSignatureTemplate } from 'src/redux/actions/documentationAction';
import {
  checkPhysicianSignAction,
  getAllPhysicianDocumentsAction,
  loadGetAllPhysician,
} from 'src/redux/actions/physicianActions';
import { requestSyncAlertsFromSignature } from 'src/redux/actions/therapist-dashboard-action';
import { getAccessToken } from 'src/routes/AuthContext';
import { getSignatureTemplateUrl } from 'src/utils/jotform-functions';

function TherapistDashboardDocSignature() {
  const dispatch = useDispatch();
  const { state } = useLocation();

  const [keys, setKeys] = useState({
    documentId: '',
    embedKey: '',
  });
  const user = useSelector((state: any) => state.getTherapistProfileReducer?.response?.data);

  const [openConfirmationModel, setOpenConfirmationModel] = useState(false);

  const signatureTemplateResponse = useSelector((state: any) => state.getSignatureTemplateReducer);
  const getDashboardSignDoc = useSelector(
    (state: any) => state.getSignatureTemplateReducer.getDashboardDoc
  );

  const [iframeRef, setIframeRef] = useState<any | null>(null);

  const updateIFrameRef = useCallback((node: any) => {
    setIframeRef(node);
  }, []);

  useEffect(() => {
    const iframeElement = iframeRef;

    if (iframeElement) {
      const interval = setInterval(async () => {
        const response = await getAccessToken();
      }, 15000);

      return () => {
        clearInterval(interval);
      };
    }
  }, [iframeRef]);

  useEffect(() => {
    if (iframeRef && getDashboardSignDoc.uuid) {
      const callSync = setInterval(() => {
        dispatch(
          requestSyncAlertsFromSignature({
            submissionId: getDashboardSignDoc.uuid,
          })
        );
      }, 3000);

      return () => {
        clearInterval(callSync);
      };
    }
  }, [iframeRef, getDashboardSignDoc]);

  useEffect(() => {
    dispatch(
      getSignatureTemplate({
        formSubmissionId: getDashboardSignDoc.uuid,
        isSupervisor: state?.source === 'PHYSICIAN' ? true : !!getDashboardSignDoc?.isForSupervisor,
      })
    );
    return () => {
      if (state?.source === 'PHYSICIAN') {
        dispatch(loadGetAllPhysician());
        dispatch(
          checkPhysicianSignAction({
            formsibmissionId: getDashboardSignDoc.uuid,
            facilityIdFromParam: getDashboardSignDoc?.facilityId,
            physicianId: user?.providerId,
          })
        );
        localStorage.removeItem('facilityId');
      } else
        dispatch(
          getAllSubmittedDocs({
            therapistUuid: getDashboardSignDoc.providerId,
            eocId: getDashboardSignDoc?.episodeOfCareId,
            signal: '',
            params: {
              type: getDashboardSignDoc?.type,
            },
          })
        );
    };
  }, []);

  useEffect(() => {
    if (
      !signatureTemplateResponse.isGetSignatureTemplate &&
      signatureTemplateResponse.response === null
    )
      return;
    setKeys({
      documentId: signatureTemplateResponse.response?.documentId,
      embedKey: signatureTemplateResponse.response?.embedKey,
    });
  }, [signatureTemplateResponse]);

  return (
    <>
      <Stack
        gap="1.5rem"
        sx={{ padding: '0 4rem' }}
      >
        <Button
          sx={{
            justifyContent: 'flex-start',
            color: '#111927',
            width: 'max-content',
            padding: '0px',
          }}
          startIcon={
            <SvgIcon>
              <ArrowBackIcon sx={{ color: '#6C737F' }} />
            </SvgIcon>
          }
        >
          <Link
            style={{ color: '#111927' }}
            to={`${state?.source === 'PHYSICIAN' ? '/physician-dashboard' : '/dashboard'}`}
          >
            <Typography variant="subtitle1">Back to Dashboard</Typography>
          </Link>
        </Button>
        <Stack
          flexDirection="row"
          gap="1rem"
          alignItems="center"
        >
          <Typography variant="h5">
            Sign a Document - {getDashboardSignDoc?.documentType}
          </Typography>
        </Stack>
      </Stack>
      {signatureTemplateResponse?.loader ? (
        <img
          src={Loader}
          alt="loader"
          style={{ width: '10%', margin: 'auto' }}
        />
      ) : (
        <Box
          sx={{ height: '100%' }}
          p={3}
        >
          <iframe
            src={getSignatureTemplateUrl(keys)}
            width={'100%'}
            ref={updateIFrameRef}
            height={'100%'}
            style={{ border: 'none' }}
            title="sign doc"
          />
        </Box>
      )}
    </>
  );
}

export default TherapistDashboardDocSignature;
